export default __webpack_public_path__ + "static/cover-video-6b2aac055f7653f8943b8526afd4f729.png";